function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "sign_in");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M287.82044,752.36475l90.51683-134.60758-90.3317,149.08876.1889,15.14674q-9.91214.07558-19.6317-.33012c-.08463-3.43852,4.756-192.78544,4.36643-196.20332.455-.137.42651-17.90737.59535-18.68831L174.398,422.85063,273.4076,553.001l.35135,3.88878,3.391-147.10442L191.53124,260.573l85.86251,123.37035c-.00093-2.00088-.90319-303.91368-.89431-305.77681.03964.989,5.68323,240.18352,5.7127,241.19141l78.03118-97.56686-77.77572,118.259,1.70308,131.58149,71.80473-128.41855c-89.18228,187.02941-69.82851,121.77085-70.5928,220.92921l104.42347-178.8855-104.106,204.41Z",
  transform: "translate(-174.39796 -78.16654)",
  fill: "#d0cde1"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 451.20408,
  cy: 704.14204,
  rx: 400,
  ry: 21,
  fill: "#d0cde1"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 130.20408,
  y: 360.14204,
  width: 577,
  height: 344,
  fill: "#3f3d56"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M416.602,485.30858a89.04381,89.04381,0,0,1-112,85.99v-132.99h98.59A88.556,88.556,0,0,1,416.602,485.30858Z",
  transform: "translate(-174.39796 -78.16654)",
  fill: "#6c63ff"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M653.06206,782.30858H544.142a58.02492,58.02492,0,0,1,108.92,0Z",
  transform: "translate(-174.39796 -78.16654)",
  fill: "#6c63ff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M881.602,604.30858v116a58,58,0,0,1,0-116Z",
  transform: "translate(-174.39796 -78.16654)",
  fill: "#6c63ff"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 220.20408,
  y: 485.14204,
  width: 398,
  height: 34,
  rx: 16.99998,
  fill: "#fff"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 220.20408,
  y: 552.14204,
  width: 398,
  height: 34,
  rx: 16.99998,
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 500.20408,
  y: 619.14204,
  width: 118,
  height: 34,
  rx: 16.99998,
  fill: "#fff"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M944.102,270.80858s18,7,19,30-5,87-5,87,22,32,5,41-19-36-19-36l-20-95S936.102,269.80858,944.102,270.80858Z",
  transform: "translate(-174.39796 -78.16654)",
  fill: "#a0616a"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M760.102,344.80858s-43,28-45,6,13-108,13-108,2-37,23-28-6,40-6,40l3,70,20-1Z",
  transform: "translate(-174.39796 -78.16654)",
  fill: "#a0616a"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M829.102,370.80858s-132-49-125,8,41,129,41,129l12,19h25l-16-103s57,32,74,27c0,0,22,147,30,158s22,144,22,144l13,16h25v-225s43-140,10-147S829.102,370.80858,829.102,370.80858Z",
  transform: "translate(-174.39796 -78.16654)",
  fill: "#2f2e41"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M754.102,513.80858s-6-11-16,0-34,24-34,24-52,12-10,22,47,0,47,0,7,2,13,4,45-5,45-11-13.24-41.85768-18.62-36.42884S754.102,513.80858,754.102,513.80858Z",
  transform: "translate(-174.39796 -78.16654)",
  fill: "#2f2e41"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M907.01823,758.91023s-14.74452-12.14254-18.21382-8.67324-21.68311,26.88706-21.68311,26.88706-48.57018,37.295-4.33662,43.36623,41.63158-10.4079,41.63158-10.4079h13.87719c1.73465,0,25.15241-10.40789,24.28509-14.74451S931.30332,755.639,927.834,758.14193,907.01823,758.91023,907.01823,758.91023Z",
  transform: "translate(-174.39796 -78.16654)",
  fill: "#2f2e41"
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 598.70408,
  cy: 120.64204,
  r: 34,
  fill: "#a0616a"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M797.102,194.80858s26,22,44,22-26,41-26,41l-39-35Z",
  transform: "translate(-174.39796 -78.16654)",
  fill: "#a0616a"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M807.102,257.80858l-.7787-7.87832s19.7787-35.12168,25.7787-38.12168,10-3,10-3,20-21,42-10,74,81,74,81-37,3-32,32c0,0,37,95,27,96s-40-6-71,8-45,5-45,5l-16-52s-30-17-29-32l-43.5,19.5,4-37,26.5-30.5S774.102,284.80858,807.102,257.80858Z",
  transform: "translate(-174.39796 -78.16654)",
  fill: "#575a89"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M741.82645,202.48438a12.55326,12.55326,0,0,1-4.93731,3.36249c-1.93652.54616-4.37631-.1236-5.14806-1.98177l1.43766-1.87114-4.30988-2.67816,1.878-2.20351-3.47143-3.76958,2.73991-2.17381-5.21663-3.73085c6.761-11.03254,14.073-22.20321,24.74734-29.51671s25.58973-9.91225,36.52479-2.99467c5.67735,3.59153,9.69193,9.29185,12.90776,15.19014,6.46739,11.86211,12.16812,23.425,13.00984,36.90933-4.06251-3.95612-9.99347-6.18553-14.056-10.14166a30.44393,30.44393,0,0,0-6.06383-4.96362c-4.24918-2.39618-9.33326-2.60816-14.09033-3.6891-3.99978-.90889-6.59524-2.7118-9.62135-5.28922-3.59988-3.06611-3.74653-1.88057-7.38167,1.57152Q751.30694,193.5056,741.82645,202.48438Z",
  transform: "translate(-174.39796 -78.16654)",
  fill: "#2f2e41"
});

var Svg35 = function Svg35(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f4721a55-7045-47d2-8f85-efcae9b7c9a1",
    "data-name": "Layer 1",
    width: 851.20408,
    height: 743.66691,
    viewBox: "0 0 851.20408 743.66691",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg35, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/35.282d27d0.svg";
export { ForwardRef as ReactComponent };